import type { GridItem } from '../components/Grid/Grid'
import { ASC } from '../context/ProductListFiltersProvider/constants'
import type { OrderMethod } from '../types/ProductsList'

export const sortGridItemsByPrice = (
	items: GridItem[],
	order: Extract<OrderMethod, 'asc' | 'desc'>
) => {
	const multiplier = order === ASC ? 1 : -1
	return items.toSorted((a, b) => {
		if (a.price === undefined) {
			return 1
		}
		if (b.price === undefined) {
			return -1
		}
		return (a.price - b.price) * multiplier
	})
}
